query getCompanyEmailFunnelsSentCounts($input: CompanyEmailFunnelsBounceInput) {
  emailSentCountsStatistics: getCompanyEmailFunnelsSentCounts(input: $input) {
    days {
      date
      sent
    }
    sent
    lastThirtyDaysSent
  }
}
